// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --bs-heading-color: #181C32;
    --bs-border-color: #F4F4F4;
    --bs-primary: #3894ad !important;
    --bs-card-border-color: var(--bs-border-color);
}

.wrapper {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    list-style: none;
    text-decoration: none;
    margin-top: 80px;
    margin-left: 280px;
    background-color: #f4f4f4;
    min-height: calc(100vh - 80px);
    height: 100%;
    padding-left: 35px !important;
    padding-right: 35px !important;
    transition: margin-left .25s linear;
}

.wrapper.hide {
    margin-left: 0px;
    transition: margin-left .25s linear;
}

.title {
    color: var(--bs-heading-color) !important;
    width: 100%;
}

.title svg{
    cursor: pointer;
}

.card {
    background-color: white !important;
    border: none !important;
}

.card .card-header {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    flex-wrap: wrap;
    min-height: 70px;
    color: var(--bs-card-cap-color);
    border-bottom: 1px solid var(--bs-card-border-color);
    background-color: white !important;
    padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
}

.table {
    --bs-table-color: var(--bs-body-color);
    --bs-table-bg: transparent;
    --bs-table-border-color: var(--bs-border-color);
    --bs-table-accent-bg: transparent;
    --bs-table-striped-color: var(--bs-body-color);
    --bs-table-striped-bg: rgba(var(--bs-gray-100-rgb), 0.75);
    --bs-table-active-color: var(--bs-body-color);
    --bs-table-active-bg: var(--bs-gray-100);
    --bs-table-hover-color: var(--bs-body-color);
    --bs-table-hover-bg: var(--bs-gray-100);
    width: 100%;
    margin-bottom: 1rem;
    color: var(--bs-table-color);
    vertical-align: top;
    border-color: var(--bs-table-border-color);
}

.table:not(.table-bordered) tr,
.table:not(.table-bordered) th,
.table:not(.table-bordered) td {
    border-color: inherit;
    border-width: inherit;
    border-style: inherit;
    text-transform: inherit;
    font-weight: inherit;
    font-size: 0.85rem;
    color: #181c32;
    height: inherit;
    min-height: inherit;
}

.table:not(.table-bordered).table-row-dashed tr {
    border-bottom-width: 1px;
    border-bottom-style: dashed;
    border-bottom-color: var(--bs-border-color);
}

.table:not(.table-bordered).table-row-dashed tr:last-child {
    border-bottom-width: 0px;
}

.table .hide {
    display: none;
}

.menu-sub-dropdown {
    display: none;
    border-radius: 0.475rem;
    background-color: var(--bs-menu-dropdown-bg-color);
    box-shadow: var(--bs-menu-dropdown-box-shadow);
    z-index: 107;
}

.menu-sub-dropdown.visible {
    display: flex !important;
    position: absolute;
    background-color: white;
    z-index: 107;
    border-radius: 0.475rem;
    box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);
    border: solid 1px var(--bs-gray-200);
}

tr.selected td {
    background-color: #f0f0f0;
}

.reload svg,
.filter svg,
.delete svg {
    margin-bottom: 3px;
}

.filter svg {
    margin-right: 3px;
}

.pe-7 {
    padding-right: 1.75rem !important;
}

.nav {
    --bs-nav-link-padding-x: 1rem;
    --bs-nav-link-padding-y: 0.5rem;
    --bs-nav-link-font-weight: ;
    --bs-nav-link-color: var(--bs-link-color);
    --bs-nav-link-hover-color: var(--bs-link-hover-color);
    --bs-nav-link-disabled-color: var(--bs-secondary-color);
    display: flex;
    flex-wrap: wrap;
    padding-left: 0;
    margin-bottom: 0;
    list-style: none;
}

.nav-line-tabs.nav-line-tabs-2x {
    border-bottom-width: 2px;
}

.nav-link {
    display: block;
    padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
    font-size: var(--bs-nav-link-font-size);
    font-weight: var(--bs-nav-link-font-weight);
    color: var(--bs-nav-link-color);
    transition: color 0.15s ease-in-out;
}

@media (min-width: 1200px) {
    .fs-2hx {
        font-size: 2rem !important;
    }
}

.selected-product-card .card-header span {
    font-size: 1.25rem !important;
    font-weight: 600 !important;
}

.selected-product-card .card-header {
    border-bottom: 0px !important;
    padding-top: 20px;
    padding-bottom: 5px;
    height: 50px !important;
    min-height: 50px !important;
}

.selected-product-card .card-header .card-title {
    height: 1.2rem !important;
}

.selected-product-card .card-body {
    border-top: none !important;
}

.card-body span {
    color: #555;
    font-weight: 400;
}

.card-body .fs-2hx {
    color: black;
}

.selected-product-card .card-body .fs-2hx {
    font-size: 1.50rem !important;
    font-weight: 700 !important;
    color: #3894ad;
}

.generalTable .select-button,
.generalTable .select-button:hover,
.generalTable .select-button:active {
    background-color: var(--bs-primary) !important;
    border-color: var(--bs-primary) !important;
    cursor: pointer !important;
}

.generalTable .selected-button svg {
    color: green;
}

.bg-singlescore {
    background-color: #b1b1ff !important;
}

.bg-blue {
    background-color: #f3b4f0 !important;
}

.bg-green {
    background-color: #f5c4af !important;
}

.bg-orange {
    background-color: #efb5b9 !important;
}

.bg-red {
    background-color: #a0d1ff !important;
}

.bg-brown {
    background-color: #b1b1ff !important;
}

.bg-black2 {
    background-color: #ffff70 !important;
}

.bg-blue span,
.bg-green span,
.bg-orange span,
.bg-red span,
.bg-brown span,
.bg-black span{
    color: black !important;
}

.circularity .title {
    font-size: 1.50rem !important;
    font-weight: 700 !important;
    color: #3894ad !important;
}

.formula{
    color: #99a1b7 !important;
    font-size: 0.80rem !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/Layout/layout.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,gCAAgC;IAChC,8CAA8C;AAClD;;AAEA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,8BAA8B;IAC9B,YAAY;IACZ,6BAA6B;IAC7B,8BAA8B;IAC9B,mCAAmC;AACvC;;AAEA;IACI,gBAAgB;IAChB,mCAAmC;AACvC;;AAEA;IACI,yCAAyC;IACzC,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kCAAkC;IAClC,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,+BAA+B;IAC/B,oDAAoD;IACpD,kCAAkC;IAClC,wDAAwD;AAC5D;;AAEA;IACI,sCAAsC;IACtC,0BAA0B;IAC1B,+CAA+C;IAC/C,iCAAiC;IACjC,8CAA8C;IAC9C,yDAAyD;IACzD,6CAA6C;IAC7C,wCAAwC;IACxC,4CAA4C;IAC5C,uCAAuC;IACvC,WAAW;IACX,mBAAmB;IACnB,4BAA4B;IAC5B,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;;;IAGI,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,uBAAuB;IACvB,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,2BAA2B;IAC3B,2CAA2C;AAC/C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,kDAAkD;IAClD,8CAA8C;IAC9C,YAAY;AAChB;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,uBAAuB;IACvB,YAAY;IACZ,uBAAuB;IACvB,oDAAoD;IACpD,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;;IAGI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,6BAA6B;IAC7B,+BAA+B;IAC/B,2BAA2B;IAC3B,yCAAyC;IACzC,qDAAqD;IACrD,uDAAuD;IACvD,aAAa;IACb,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,kEAAkE;IAClE,uCAAuC;IACvC,2CAA2C;IAC3C,+BAA+B;IAC/B,mCAAmC;AACvC;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,6BAA6B;IAC7B,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;;;IAGI,8CAA8C;IAC9C,0CAA0C;IAC1C,0BAA0B;AAC9B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;;;;;IAMI,uBAAuB;AAC3B;;AAEA;IACI,6BAA6B;IAC7B,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;AACjC","sourcesContent":[":root {\n    --bs-heading-color: #181C32;\n    --bs-border-color: #F4F4F4;\n    --bs-primary: #3894ad !important;\n    --bs-card-border-color: var(--bs-border-color);\n}\n\n.wrapper {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    list-style: none;\n    text-decoration: none;\n    margin-top: 80px;\n    margin-left: 280px;\n    background-color: #f4f4f4;\n    min-height: calc(100vh - 80px);\n    height: 100%;\n    padding-left: 35px !important;\n    padding-right: 35px !important;\n    transition: margin-left .25s linear;\n}\n\n.wrapper.hide {\n    margin-left: 0px;\n    transition: margin-left .25s linear;\n}\n\n.title {\n    color: var(--bs-heading-color) !important;\n    width: 100%;\n}\n\n.title svg{\n    cursor: pointer;\n}\n\n.card {\n    background-color: white !important;\n    border: none !important;\n}\n\n.card .card-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: stretch;\n    flex-wrap: wrap;\n    min-height: 70px;\n    color: var(--bs-card-cap-color);\n    border-bottom: 1px solid var(--bs-card-border-color);\n    background-color: white !important;\n    padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);\n}\n\n.table {\n    --bs-table-color: var(--bs-body-color);\n    --bs-table-bg: transparent;\n    --bs-table-border-color: var(--bs-border-color);\n    --bs-table-accent-bg: transparent;\n    --bs-table-striped-color: var(--bs-body-color);\n    --bs-table-striped-bg: rgba(var(--bs-gray-100-rgb), 0.75);\n    --bs-table-active-color: var(--bs-body-color);\n    --bs-table-active-bg: var(--bs-gray-100);\n    --bs-table-hover-color: var(--bs-body-color);\n    --bs-table-hover-bg: var(--bs-gray-100);\n    width: 100%;\n    margin-bottom: 1rem;\n    color: var(--bs-table-color);\n    vertical-align: top;\n    border-color: var(--bs-table-border-color);\n}\n\n.table:not(.table-bordered) tr,\n.table:not(.table-bordered) th,\n.table:not(.table-bordered) td {\n    border-color: inherit;\n    border-width: inherit;\n    border-style: inherit;\n    text-transform: inherit;\n    font-weight: inherit;\n    font-size: 0.85rem;\n    color: #181c32;\n    height: inherit;\n    min-height: inherit;\n}\n\n.table:not(.table-bordered).table-row-dashed tr {\n    border-bottom-width: 1px;\n    border-bottom-style: dashed;\n    border-bottom-color: var(--bs-border-color);\n}\n\n.table:not(.table-bordered).table-row-dashed tr:last-child {\n    border-bottom-width: 0px;\n}\n\n.table .hide {\n    display: none;\n}\n\n.menu-sub-dropdown {\n    display: none;\n    border-radius: 0.475rem;\n    background-color: var(--bs-menu-dropdown-bg-color);\n    box-shadow: var(--bs-menu-dropdown-box-shadow);\n    z-index: 107;\n}\n\n.menu-sub-dropdown.visible {\n    display: flex !important;\n    position: absolute;\n    background-color: white;\n    z-index: 107;\n    border-radius: 0.475rem;\n    box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);\n    border: solid 1px var(--bs-gray-200);\n}\n\ntr.selected td {\n    background-color: #f0f0f0;\n}\n\n.reload svg,\n.filter svg,\n.delete svg {\n    margin-bottom: 3px;\n}\n\n.filter svg {\n    margin-right: 3px;\n}\n\n.pe-7 {\n    padding-right: 1.75rem !important;\n}\n\n.nav {\n    --bs-nav-link-padding-x: 1rem;\n    --bs-nav-link-padding-y: 0.5rem;\n    --bs-nav-link-font-weight: ;\n    --bs-nav-link-color: var(--bs-link-color);\n    --bs-nav-link-hover-color: var(--bs-link-hover-color);\n    --bs-nav-link-disabled-color: var(--bs-secondary-color);\n    display: flex;\n    flex-wrap: wrap;\n    padding-left: 0;\n    margin-bottom: 0;\n    list-style: none;\n}\n\n.nav-line-tabs.nav-line-tabs-2x {\n    border-bottom-width: 2px;\n}\n\n.nav-link {\n    display: block;\n    padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);\n    font-size: var(--bs-nav-link-font-size);\n    font-weight: var(--bs-nav-link-font-weight);\n    color: var(--bs-nav-link-color);\n    transition: color 0.15s ease-in-out;\n}\n\n@media (min-width: 1200px) {\n    .fs-2hx {\n        font-size: 2rem !important;\n    }\n}\n\n.selected-product-card .card-header span {\n    font-size: 1.25rem !important;\n    font-weight: 600 !important;\n}\n\n.selected-product-card .card-header {\n    border-bottom: 0px !important;\n    padding-top: 20px;\n    padding-bottom: 5px;\n    height: 50px !important;\n    min-height: 50px !important;\n}\n\n.selected-product-card .card-header .card-title {\n    height: 1.2rem !important;\n}\n\n.selected-product-card .card-body {\n    border-top: none !important;\n}\n\n.card-body span {\n    color: #555;\n    font-weight: 400;\n}\n\n.card-body .fs-2hx {\n    color: black;\n}\n\n.selected-product-card .card-body .fs-2hx {\n    font-size: 1.50rem !important;\n    font-weight: 700 !important;\n    color: #3894ad;\n}\n\n.generalTable .select-button,\n.generalTable .select-button:hover,\n.generalTable .select-button:active {\n    background-color: var(--bs-primary) !important;\n    border-color: var(--bs-primary) !important;\n    cursor: pointer !important;\n}\n\n.generalTable .selected-button svg {\n    color: green;\n}\n\n.bg-singlescore {\n    background-color: #b1b1ff !important;\n}\n\n.bg-blue {\n    background-color: #f3b4f0 !important;\n}\n\n.bg-green {\n    background-color: #f5c4af !important;\n}\n\n.bg-orange {\n    background-color: #efb5b9 !important;\n}\n\n.bg-red {\n    background-color: #a0d1ff !important;\n}\n\n.bg-brown {\n    background-color: #b1b1ff !important;\n}\n\n.bg-black2 {\n    background-color: #ffff70 !important;\n}\n\n.bg-blue span,\n.bg-green span,\n.bg-orange span,\n.bg-red span,\n.bg-brown span,\n.bg-black span{\n    color: black !important;\n}\n\n.circularity .title {\n    font-size: 1.50rem !important;\n    font-weight: 700 !important;\n    color: #3894ad !important;\n}\n\n.formula{\n    color: #99a1b7 !important;\n    font-size: 0.80rem !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
